module.exports = __webpack_public_path__ + "static/img/banner4.de3e8ddb.png";